<template>
  <el-menu
    :default-active="activeMenu"
    :collapse="!sidebarOpened"
    background-color="#001529"
    text-color="#a6adb4"
    active-text-color="#409EFF"
    router
    unique-opened
  >
    <template v-for="group in menuGroups">
      <el-menu-item
        v-if="group.children.length === 1 && group.children[0].meta.title === group.name"
        :key="group.name"
        :index="group.children[0].path"
      >
        <i :class="group.icon"></i>
        <span slot="title">{{ group.name }}</span>
      </el-menu-item>
      <el-submenu v-else :key="group.name" :index="group.name">
        <template slot="title">
          <i :class="group.icon"></i>
          <span>{{ group.name }}</span>
        </template>
        <el-menu-item
          v-for="item in group.children"
          :key="item.path"
          :index="item.path"
        >
          <i :class="item.meta.icon"></i>
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters(['sidebarOpened', 'hasPermission']),
    activeMenu() {
      return this.$route.path
    },
    menuGroups() {
      const routes = this.$router.options.routes
      const layoutRoute = routes.find(r => r.path === '/')
      if (!layoutRoute) return []

      const groupMap = {}
      const groupIcons = {
        '首页': 'el-icon-s-home',
        '组态监控': 'el-icon-data-board',
        '实时监控': 'el-icon-monitor',
        '能源管理': 'el-icon-lightning',
        '报警管理': 'el-icon-bell',
        '报表管理': 'el-icon-data-analysis',
        '碳管理': 'el-icon-data-analysis',
        '设备管理': 'el-icon-cpu',
        '系统管理': 'el-icon-setting'
      }

      for (const child of layoutRoute.children || []) {
        const group = child.meta?.group
        if (!group) continue
        if (child.meta?.hidden) continue
        // 无权访问的菜单项直接不渲染；某分组下全部项都无权时，该分组也不会出现
        if (!this.hasPermission(child.meta?.permission)) continue
        if (!groupMap[group]) {
          groupMap[group] = {
            name: group,
            icon: groupIcons[group] || 'el-icon-menu',
            children: []
          }
        }
        groupMap[group].children.push(child)
      }

      return Object.values(groupMap)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  border-right: none;
}
</style>
